import React, { Component } from "react";
import "./style.css";
import { get } from "../../../utils/request";
let params = { majorCategoryId: null, majorName: null, majorTypeId: null };
class KeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      majors: [],
    };
  }
  render() {
    const { placeholder, visible } = this.props;
    return (
      <div
        className={
          visible === true ? "keySearch_box" : "keySearch_box display_none"
        }
      >
        <div className="keySearch_box_left fl">
          <div className="keySearch_box_left_div">
            <div className="keySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="keySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
          </div>
        </div>
        <div className="keySearch_box_right fl">
          <div
            onClick={this.handleSearch}
            className="keySearch_box_right_txt fl"
          >
            {this.state.clickName}
          </div>
        </div>
        <div className="clear"></div>
        <div className="keySearch_box_item">
          {this.state.majors.map((item, index) => {
            return (
              <div
                key={index}
                onClick={this.handleClick.bind(this, item)}
                className="keySearch_item"
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 搜索查询
   */
  handleSearch = () => {
    if (this.state.clickName === "取消") {
      params = { majorCategoryId: null, majorName: null, majorTypeId: null };
      this.props.handleVisibleSearch();
      this.props.handleShowDataList();
      this.setState({
        clickName: "取消",
        majors: [],
      });
    } else {
      params = {
        majorCategoryId: null,
        majorName: this.state.name,
        majorTypeId: null,
      };
      this.setState({
        clickName: "取消",
        majors: [],
      });
      this.props.handleVisibleSearch();
      this.props.handleShowDataList();
    }

    setTimeout(() => {
      this.setState({
        name: "",
      });
      this.props.handleChangeParams(params);
      this.props.requestFilterMajorList();
      this.props.handleAddScroll();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  };
  /**
   * 点击专业
   */
  handleClick = (item) => {
    if (this.state.clickName === "取消") {
      this.props.handleShowDataList();
      this.props.handleVisibleSearch();
      this.setState({
        clickName: "取消",
        majors: [],
      });
    } else {
      params.majorName = item;
      this.setState({
        clickName: "取消",
        majors: [],
      });
      setTimeout(() => {
        this.props.handleChangeParams(params);
        this.props.requestFilterMajorList();
        this.props.handleVisibleSearch();
        this.props.handleShowDataList();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    }
  };
  /**
   * 输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      this.setState({
        clickName: "搜索",
      });
      get("/public/v1/major/search/" + e.target.value).then((res) => {
        this.setState({
          majors: res.data,
        });
      });
    } else {
      this.setState({
        clickName: "取消",
        majors: [],
      });
    }
  };
}
export default KeySearch;



// WEBPACK FOOTER //
// ./src/components/Search/KeySearch/index.js